import { createSlice } from "@reduxjs/toolkit";

export type InitialState = {
  result: string[];
  loading: boolean;

  yearfrom: string[];
  publisher_name: string[];
  gender: string[];
  age_group: string[];
  diagnosis: string[];
  presenting_centre: string[];
  primary_site: string[];
  category: string[];
  dmg: string[];
  stage_of_cancer: string[];
  sort: string;
  page: number;
  rows: number;
  comment_count: number;
};

const initialState: InitialState = {
  result: [],
  loading: false,

  yearfrom: [],
  publisher_name: [],
  gender: [],
  age_group: [],
  diagnosis: [],
  presenting_centre: [],
  primary_site: [],
  category: [],
  dmg: [],
  stage_of_cancer: [],
  sort: " title asc",
  page: 1,
  rows: 15,
  comment_count: 0,
};

export const ncgDetailsSlice = createSlice({
  name: "ncgDetails",
  initialState,
  reducers: {
    browseNCGSearchResult(state, { payload }) {
      state.result = payload;
    },
    updateNCGLoadingState(state, { payload }) {
      state.loading = payload;
    },

    updateNCGYearFrom(state, { payload }) {
      state.yearfrom = payload;
    },
    updateNCGPublisherName(state, { payload }) {
      state.publisher_name = payload;
    },
    updateNCGGender(state, { payload }) {
      state.gender = payload;
    },
    updateNCGAgeGroup(state, { payload }) {
      state.age_group = payload;
    },
    updateNCGDiagnosis(state, { payload }) {
      state.diagnosis = payload;
    },
    updateNCGPresentingCentre(state, { payload }) {
      state.presenting_centre = payload;
    },
    updateNCGPrimarySite(state, { payload }) {
      state.primary_site = payload;
    },
    updateNCGCategory(state, { payload }) {
      state.category = payload;
    },
    updateNCGDmg(state, { payload }) {
      state.dmg = payload;
    },
    updateNCGStageOfCancer(state, { payload }) {
      state.stage_of_cancer = payload;
    },
    updateNCGSort(state, { payload }) {
      state.sort = payload;
    },

    updateNCGBrowserRow(state, { payload }) {
      state.rows = payload;
    },

    updateNCGBrowserPage(state, { payload }) {
      state.page = payload;
    },

    updateNCGBrowserCommentsCount(state, { payload }) {
      state.comment_count = payload;
    },

    clearNCGAllFilters(state) {
      state.yearfrom = [];
      state.publisher_name = [];
      state.gender = [];
      state.age_group = [];
      state.diagnosis = [];
      state.presenting_centre = [];
      state.primary_site = [];
      state.category = [];
      state.dmg = [];
      state.stage_of_cancer = [];
      state.comment_count = 0;
    },
    clearNCGResults(state) {
      state.result = [];
    },

    // clearSource(state) {
    //   state.sourceType = [];
    // },
    // clearSubject(state) {
    //   state.subject = [];
    // },
  },
});

export const {
  browseNCGSearchResult,
  updateNCGLoadingState,
  updateNCGYearFrom,
  updateNCGPublisherName,
  updateNCGGender,
  updateNCGAgeGroup,
  updateNCGDiagnosis,
  updateNCGPresentingCentre,
  updateNCGPrimarySite,
  updateNCGCategory,
  updateNCGDmg,
  updateNCGStageOfCancer,
  updateNCGSort,
  updateNCGBrowserRow,
  updateNCGBrowserPage,
  clearNCGAllFilters,
  clearNCGResults,
  updateNCGBrowserCommentsCount,
} = ncgDetailsSlice.actions;

export default ncgDetailsSlice.reducer;
